export const REFERRAL_URL =
  'https://www.bybit.com/invite?ref=ELXZXNV&medium=referral&utm_campaign=evergreen&share_to=link';

export const REFERRAL_CODE = 'ELXZXNV';

type TrackingEvent = 'page_view' | 'view_content' | 'cta_click' | 'referral_click';

type TrackingPayload = Record<string, string | number | boolean | undefined>;

interface TrackingWindow extends Window {
  dataLayer?: unknown[];
  gtag?: (...args: unknown[]) => void;
  fbq?: (...args: unknown[]) => void;
  ttq?: { track: (event: string, payload?: TrackingPayload) => void };
}

const metaEventMap: Record<TrackingEvent, string> = {
  page_view: 'PageView',
  view_content: 'ViewContent',
  cta_click: 'ClickButton',
  referral_click: 'Lead',
};

const tiktokEventMap: Record<TrackingEvent, string> = {
  page_view: 'Pageview',
  view_content: 'ViewContent',
  cta_click: 'ClickButton',
  referral_click: 'SubmitForm',
};

/**
 * Single funnel-wide event dispatcher. Fires into Google Analytics, Meta Pixel and
 * TikTok Pixel when their scripts are present, and always pushes to dataLayer so a
 * tag manager can pick the event up later without code changes.
 */
export function trackEvent(event: TrackingEvent, payload: TrackingPayload = {}): void {
  if (typeof window === 'undefined') return;
  const w = window as TrackingWindow;
  const data = { event, ...payload };

  w.dataLayer = w.dataLayer || [];
  w.dataLayer.push(data);

  try {
    w.gtag?.('event', event, payload);
    w.fbq?.('track', metaEventMap[event], payload);
    w.ttq?.track(tiktokEventMap[event], payload);
  } catch {
    /* pixels are optional — never break the page for analytics */
  }
}

/** Every CTA that sends the visitor to the referral link routes through here. */
export function trackReferralClick(location: string, label: string): void {
  trackEvent('cta_click', { cta_location: location, cta_label: label });
  trackEvent('referral_click', {
    cta_location: location,
    cta_label: label,
    referral_code: REFERRAL_CODE,
  });
}
